export { workspaceNamespace } from "@amazon-connect/app-controller";
